import { Link } from 'react-router-dom';
import { Calendar, Cloud, Book, Image, LayoutDashboard, Mail } from 'lucide-react';
import dashboardScreenshot from '../assets/dashboard-screenshot.jpg';
import EmailSignup from '../components/EmailSignup';

function HomePage() {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-sky-100 to-sky-200 py-20">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-10 md:mb-0">
              <h1 className="text-4xl md:text-5xl font-bold mb-4 glow-text">
                Family Dashboard by Ryken Labs
              </h1>
              <p className="text-xl mb-8 text-slate-700">
                Your family's complete information center - weather, calendar, activities, and more on a single screen.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link 
                  to="/features" 
                  className="btn-primary flex items-center justify-center gap-2"
                >
                  <LayoutDashboard size={20} />
                  <span>See Features</span>
                </Link>
                <a 
                  href="#signup" 
                  className="btn-secondary flex items-center justify-center gap-2"
                >
                  <Mail size={20} />
                  <span>Get Updates</span>
                </a>
              </div>
            </div>
            <div className="md:w-1/2">
              <div className="relative">
                <div className="absolute -inset-1 bg-blue-500 rounded-lg blur-lg opacity-30"></div>
                <img 
                  src={dashboardScreenshot} 
                  alt="Family Dashboard in action" 
                  className="relative rounded-lg shadow-2xl border border-slate-700"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Key Features Overview */}
      <section className="py-16 bg-slate-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 glow-text">Everything Your Family Needs At A Glance</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="dashboard-card">
              <Calendar size={28} className="mb-3" style={{ color: 'var(--ryken-primary)' }} />
              <h3 className="text-xl font-semibold mb-3" style={{ color: 'var(--ryken-accent)' }}>Calendar & Events</h3>
              <p className="text-slate-600">See everyone's schedule in one place with color-coded events from Google Calendar.</p>
            </div>
            
            <div className="dashboard-card">
              <Cloud size={28} className="mb-3" style={{ color: 'var(--ryken-primary)' }} />
              <h3 className="text-xl font-semibold mb-3" style={{ color: 'var(--ryken-accent)' }}>Weather & Time</h3>
              <p className="text-slate-600">Always know the forecast with real-time weather updates and 5-day predictions.</p>
            </div>
            
            <div className="dashboard-card">
              <Book size={28} className="mb-3" style={{ color: 'var(--ryken-secondary)' }} />
              <h3 className="text-xl font-semibold mb-3" style={{ color: 'var(--ryken-accent)' }}>Kids Activities</h3>
              <p className="text-slate-600">Daily reading, math that adapts to each child, a mystery image reveal, and a Question of the Day to spark conversation.</p>
            </div>
          </div>
          
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="dashboard-card">
              <Book size={28} className="mb-3" style={{ color: 'var(--ryken-secondary)' }} />
              <h3 className="text-xl font-semibold mb-3" style={{ color: 'var(--ryken-accent)' }}>Word of the Day</h3>
              <p className="text-slate-600">Expand vocabulary with a new word each day, complete with pronunciation and definition.</p>
            </div>
            
            <div className="dashboard-card">
              <Image size={28} className="mb-3" style={{ color: 'var(--ryken-primary)' }} />
              <h3 className="text-xl font-semibold mb-3" style={{ color: 'var(--ryken-accent)' }}>Photo Display</h3>
              <p className="text-slate-600">Show your favorite family moments — send photos from your phone or a local folder, no cloud needed.</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Email Signup Form */}
      <section id="signup">
        <EmailSignup />
      </section>
    </div>
  );
}

export default HomePage;